import { Button } from '@vivaldis/antd-ui'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ActionBar as BaseActionBar } from '../../../../../ActionBar'

interface Props {
  onGoBack: () => void
}

export const ActionBar = ({ onGoBack }: Props) => {
  const [t] = useTranslation('web_ui')

  const handleCloseButtonClick = useCallback(() => {
    onGoBack()
  }, [onGoBack])

  return (
    <BaseActionBar
      rightContent={
        <Button
          onClick={handleCloseButtonClick}
          type="primary"
          shape="round"
          size="large"
        >
          {t(
            'edit_employee_personal_information_form.steps.ocr_succeeded.submit_button'
          )}
        </Button>
      }
    />
  )
}
